import { createContext } from '@lit/context';
export class AuthenticationState {
    constructor() {
        this.isAuthenticated = false;
    }
}
export const authenticationContext = createContext(Symbol('authentication'));
